import rangeHandler from 'helpers/rangeHandler'
import { get } from 'lodash'

const state = {
    microLearningSection: null,
    microLearningSections: null,
    currentSessionSequences: {},
    microLearningVideoLogs: null,
    totalWatchedPercentage: null,
    microLearningTotalDuration: null,
    lastWatchedSectionVideoLog: null,
    microLearningSectionTitle: null
}

const mutations = {
    ASSIGN_MICROLEARNING_SECTION (state, section) {
        state.microLearningSection = section
    },
    ASSIGN_MICROLEARNING_SECTIONS (state, sections) {
        state.microLearningSections = sections
        state.microLearningSection = null
    },
    ASSIGN_MICROLEARNING_PROGRESS (state, { currentPosition, currentSessionSequences, videoDuration, liveWatchedTime, elementId }) {
        let sectionElementId = null
        if (!elementId) {
            sectionElementId = state.microLearningSection.elementId
        } else {
            sectionElementId = elementId
        }
        if (state.currentSessionSequences[sectionElementId]) {
            const unifiedSequences = rangeHandler.unifyRanges(state.currentSessionSequences[sectionElementId], currentSessionSequences)
            state.currentSessionSequences[sectionElementId] = unifiedSequences
        } else {
            state.currentSessionSequences[sectionElementId] = currentSessionSequences
        }
    },
    ASSIGN_MICROLEARNING_TOTAL_DURATION (state, duration) {
        state.microLearningTotalDuration = duration
    },
    UPDATE_MICROLEARNING_WATCHED_PERCENTAGE (state) {
        let currentlyWatchedDuration = 0
        state.totalWatchedPercentage = null
        for (const key in state.currentSessionSequences) {
            currentlyWatchedDuration += rangeHandler.sumRanges(state.currentSessionSequences[key])
        }
        if(state.microLearningTotalDuration === 0) {
            state.totalWatchedPercentage = 100
            return
        }
        state.totalWatchedPercentage = Math.floor((currentlyWatchedDuration / state.microLearningTotalDuration) * 100)
    },
    ASSIGN_MICROLEARNING_VIDEOLOGS (state, videoLogs) {
        state.microLearningVideoLogs = videoLogs
    },
    EMPTY_MICROLEARNING_PROGRESS (state) {
        state.currentSessionSequences = {}
    },
    EMPTY_MICROLEARNING_VIDEOLOGS (state) {
        state.microLearningVideoLogs = null
        state.lastWatchedSectionVideoLog = null
    },
    ASSIGN_LAST_WATCHED_SECTION_INFO (state, lastWatchedSectionVideoLog) {
        state.lastWatchedSectionVideoLog = lastWatchedSectionVideoLog
    },
    CLEAR_MICROLEARNING_SECTIONS (state) {
        state.microLearningSections = null
        state.microLearningSection = null
    },
    ASSIGN_MICROLEARNING_SECTION_TITLE (state, section) {
        state.microLearningSectionTitle = section
    }
}

const actions = {
    async assignMicroLearningSection (store, section) {
        store.commit('ASSIGN_MICROLEARNING_SECTION', section)
    },
    async assignMicroLearningSections (store, sections) {
        const onlyWatchableSections = sections.filter(section => section.type !== 'section')
        const totalDurationOfMicroLearning = onlyWatchableSections.reduce((accumulator, microLearningElement) => +accumulator + +microLearningElement.duration, 0)
        store.commit('ASSIGN_MICROLEARNING_SECTIONS', onlyWatchableSections)
        store.commit('ASSIGN_MICROLEARNING_TOTAL_DURATION', totalDurationOfMicroLearning)
        store.commit('UPDATE_MICROLEARNING_WATCHED_PERCENTAGE')
    },
    async microLearningVideoProgress (store, { currentPosition, currentSessionSequences, videoDuration, liveWatchedTime, elementId }) {
        store.commit('ASSIGN_MICROLEARNING_PROGRESS', { currentPosition, currentSessionSequences, videoDuration, liveWatchedTime, elementId })
        store.commit('UPDATE_MICROLEARNING_WATCHED_PERCENTAGE')
    },
    async setMicroLearningVideoLogs (store, videoLogs) {
        store.commit('EMPTY_MICROLEARNING_PROGRESS')
        store.commit('EMPTY_MICROLEARNING_VIDEOLOGS')
        if (videoLogs.length === 0) {
            return
        }
        videoLogs.forEach((videoLog) => {
            let log = {
                currentPosition: videoLog.position,
                currentSessionSequences: videoLog.details.timeRanges,
                videoDuration: videoLog.durationSeconds,
                liveWatchedTime: videoLog.totalWatched,
                elementId: videoLog.elementId
            }
            store.commit('ASSIGN_MICROLEARNING_PROGRESS', log)
        })
        store.commit('ASSIGN_MICROLEARNING_VIDEOLOGS', videoLogs)

        const lastWatchedSectionVideoLog = videoLogs.reduce((a, b) => (a.updatedAt > b.updatedAt ? a : b))
        store.commit('ASSIGN_LAST_WATCHED_SECTION_INFO', lastWatchedSectionVideoLog)
    },
    async clearMicroLearningSections (store) {
        store.commit('CLEAR_MICROLEARNING_SECTIONS')
    },
    setCurrentMicroLearningSectionTitle (store, section) {
        store.commit('ASSIGN_MICROLEARNING_SECTION_TITLE', section)
    }
}

const getters = {
    getMicroLearningSection: (state) => state.microLearningSection,
    getMicroLearningSections: (state) => state.microLearningSections,
    isMicroLearningCourse: state => state.microLearningSections !== null,
    getCurrentSessionSequences: (state) => state.currentSessionSequences,
    getMicroLearningTotalDuration: (state) => state.microLearningTotalDuration,
    getMicroLearningCurrentWatchedPercent: (state) => state.totalWatchedPercentage,
    canMicroLearningTestBeOpen: (state, getters) => (getters.getMicroLearningCurrentWatchedPercent >= (config.percentageVideoRequire * 100)) || (!state.microLearningTotalDuration),
    getMicroLearningVideoLogs: (state) => state.microLearningVideoLogs,
    getLastWatchedSectionInfo: (state) => state.lastWatchedSectionVideoLog,
    getMicroLearningSectionTitle: (state) => state.microLearningSectionTitle
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
